import React from 'react';
import './History.css';
import { Heading, PageTitle } from '../../../components';
import { historyData } from '../../../constants';
import { FaLeaf, FaHistory, FaLandmark } from 'react-icons/fa';

const History = () => {

    // Funkcja pomocnicza do wyboru ikony na podstawie danych
    const renderIcon = (type) => {
        if (type === 'landmark') return <FaLandmark />;
        return <FaHistory />;
    };

    return (
        <>
            <PageTitle title={historyData.title} page={historyData.page} />

            <section className='history-section'>

                <Heading title={historyData.heading} subTitle={historyData.subHeading} />

                {/* WST�P */}
                <div className='history-intro'>
                    <p>{historyData.intro}</p>
                </div>

                <div className='history-container'>

                    {/* Generowanie blok�w historii z danych */}
                    {historyData.blocks.map((block) => (
                        <div key={block.id} className={`history-block ${block.reverse ? 'reverse' : ''}`}>
                            <div className='image'>
                                <img src={block.image} alt={block.title} />
                            </div>
                            <div className='content'>
                                <div className='icon-wrapper'>
                                    {renderIcon(block.iconType)}
                                </div>
                                <h3>{block.title}</h3>
                                {block.paragraphs.map((p, index) => (
                                    <p key={index}>{p}</p>
                                ))}
                            </div>
                        </div>
                    ))}

                    {/* BLOK 4: Warto�ci i Misja */}
                    <div className='heritage-mission-wrapper'>

                        {/* Dziedzictwo */}
                        <div className='heritage-box'>
                            <h3>{historyData.heritage.title}</h3>
                            <p>{historyData.heritage.intro}</p>
                            <ul>
                                {historyData.heritage.list.map((item, index) => (
                                    <li key={index}>
                                        <FaLeaf className='icon' /> {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Misja */}
                        <div className='mission-box'>
                            <h3>{historyData.mission.title}</h3>
                            <p>{historyData.mission.text}</p>
                            <h4>{historyData.mission.slogan}</h4>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};

export default History;